module.exports = __webpack_public_path__ + "static/people_pop23-6966441c5f4f554f7bc2f18ef39dd6e1.png";